import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'span[textOverFlowTooltip]',
  standalone: true,
})
export class TextOverFlowTooltipDirective {
  @Input() textOverFlowTooltip: string = '';

  constructor() {}

  @HostListener('mouseover', ['$event'])
  isOverFlow(event: any) {
    let disabledTooltip;
    if (this.textOverFlowTooltip === 'parent') {
      disabledTooltip = !this.isOverflowParent(event.target);
    } else if (this.textOverFlowTooltip === 'table') {
      disabledTooltip = !this.calculateForMaxContent(event.target);
    } else if (this.textOverFlowTooltip === 'max-width') {
      disabledTooltip = !this.calculateForPreMaxWidth(event.target);
    } else {
      disabledTooltip = !this.calculate(event.target);
    }

    if (disabledTooltip) {
      event.target.classList.add('disableTooltip');
    } else {
      event.target.classList.remove('disableTooltip');
    }
  }

  calculateForMaxContent(element: HTMLElement) {
    const hiddenWidth = element.clientWidth;
    element.style.width = 'max-content';
    const fullWidth = element.clientWidth;
    element.style.width = '100%';
    return hiddenWidth < fullWidth;
  }

  calculateForPreMaxWidth(element: HTMLElement) {
    const prevMaxWidth = element.style.maxWidth;
    const hiddenWidth = element.clientWidth;
    element.style.maxWidth = 'unset';
    const fullWidth = element.clientWidth;
    element.style.maxWidth = prevMaxWidth;
    return hiddenWidth < fullWidth;
  }

  calculate(element: HTMLElement) {
    const hiddenWidth = element.clientWidth;
    element.style.overflow = 'visible';
    const fullWidth = getTextWidth(element);
    element.style.overflow = 'hidden';
    return hiddenWidth < fullWidth;
  }

  isOverflowParent(element: any) {
    const parentWidth = element.clientWidth;
    const childWidth = element.firstElementChild?.getBoundingClientRect().width;
    return parentWidth < childWidth;
  }
}

function getTextWidth(element: any) {
  // Create a clone with same styling but no constraints
  const clone = element.cloneNode(true);
  clone.style.position = 'absolute';
  clone.style.visibility = 'hidden';
  clone.style.whiteSpace = 'nowrap';
  clone.style.width = 'auto';

  // Add to document to get computed values
  document.body.appendChild(clone);
  const width = clone.offsetWidth;
  document.body.removeChild(clone);

  return width;
}
